import { EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { Invoice } from '@app/resources/services';
export const invoiceAdapter: EntityAdapter<Invoice> = createEntityAdapter<Invoice>({
  sortComparer: (a, b) => b.InvoiceId - a.InvoiceId, // we only have one loyalty program. If we need multiple, add a comparator function
  selectId: (e) => e.InvoiceId,
});

export const selectInvoiceEntities = invoiceAdapter.getSelectors().selectEntities;
